import { Box, Stack } from 'braid-design-system';

import { useTypedSelector } from 'src/modules/hooks/useTypedSelector';

import { useResumes } from '../../../data';
import type { Resume } from '../../../types';
import { ResumeDetailItem } from '../ResumeDetailItem/ResumeDetailItem';

export const ResumeItemList = () => {
  const { resumes } = useResumes();
  const lastUploadedResume = useTypedSelector(
    (store) => store.resume.lastUploadedResume,
  );
  const deleteRequestedResume = useTypedSelector(
    (store) => store.resume.deleteRequestedResume,
  );
  const downloadRequestedResumes = useTypedSelector(
    (store) => store.resume.downloadRequestedResumes,
  );
  return (
    <Stack
      space="small"
      component="ul"
      data={{ automation: 'resume-item-list' }}
    >
      {resumes.map((resume: Resume) => {
        const requestedResume = downloadRequestedResumes.find(
          (res) => res.id === resume.id,
        );

        return (
          <Box component="li" key={`resume-${resume.id}`}>
            <ResumeDetailItem
              {...resume}
              highlightResume={resume.id === lastUploadedResume}
              deleteRequested={
                deleteRequestedResume
                  ? deleteRequestedResume === resume.id
                  : false
              }
              fetchedStatus={requestedResume?.fetchedStatus}
            />
          </Box>
        );
      })}
    </Stack>
  );
};
